var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitFill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3 0.832031H14.6C18 0.832031 19.9 2.73203 19.9 6.13203V15.432C19.9 18.832 18 20.732 14.6 20.732H5.3C1.9 20.732 0 18.832 0 15.432V6.13203C0 2.73203 1.9 0.832031 5.3 0.832031ZM9.2 10.032H6.4C6.2 10.032 6 10.032 5.8 10.232C5.7 10.432 5.6 10.632 5.6 10.832C5.6 11.332 6 11.632 6.4 11.632H13.7C14.2 11.632 14.5 11.232 14.5 10.832C14.5 10.432 14.1 10.032 13.7 10.032H10.9",
    fill: "#00538F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitFill);
export default __webpack_public_path__ + "static/media/split-fill.23e9a3fa05b014eadcdecf9b8a27f0a4.svg";
export { ForwardRef as ReactComponent };